export const DESIRED_RESULTS_COUNT = 100;